import React from 'react'
export const StandardLaser = (props) => {
  const { delivery } = props
  return (
    <div className="booking-laser">
      <div style={{ width: '210mm', margin: '0 auto 20px', background: '#fff', border: '2px solid #000' }}>
        <div className="top-main-info">
          <table cellSpacing="0" cellPadding="0">
            <tr>
              <td style={{ background: '#000' }}>
                <img src="http://buscrs.com/images/01.png" alt="" />
              </td>
              <td className="item" style={{ width: '100%' }}>
                <div>
                  <table style={{ width: '100%' }} className="top-table">
                    <tbody>
                      <tr>
                        <td className="logo-box" rowSpan="2">
                          <div style={{ textAlign: 'center' }}>
                            <img src="https://mavenconnect.biz/maventech-logo.png" width="60px" height="60px" alt="Logo" />
                          </div>
                          <div className="medium-tx">
                            BOOKING TIME: <span>9:00 AM</span>
                          </div>
                        </td>
                        <td className="shade-bg">WAYBILL NO (LRN)</td>
                        <td className="shade-bg">Scan</td>
                        <td className="shade-bg">Total amount</td>
                        <td className="shade-bg">Payment Type</td>
                      </tr>
                      <tr>
                        <td>
                          <div>
                            <div className="medium-tx bold-tx">WB123456</div>
                            <div className="large-tx bold-tx">{`${delivery ? 'DELIVERED' : 'BOOKED'}`} </div>
                          </div>
                        </td>
                        <td>
                          <img
                            src="https://cdn.pixabay.com/photo/2013/07/12/14/42/qr-code-148603_1280.png"
                            alt="QR Code"
                            width="60px"
                            height="60px"
                          />
                        </td>
                        <td className="large-tx bold-tx">₹12345.00</td>
                        <td>
                          <div>
                            <div class="medium-tx bold-tx">
                              on account <br /> Manual
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="itenerary-box">
                    <table style={{ margin: '5px' }}>
                      <tr>
                        <td className="td-item">
                          <table>
                            <thead className="shade-bg bold-tx" style={{ lineHeight: '22px' }}>
                              <tr>
                                <td style={{ width: '40%' }}>SOURCE CITY</td>
                                <td>:</td>
                                <td style={{ width: '60%' }}>Bangalore</td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td style={{ paddingTop: '5px' }}>SOURCE BRANCH</td>
                                <td style={{ paddingTop: '5px' }}>:</td>
                                <td style={{ paddingTop: '5px' }}>
                                  Maven Operation Bangalore (2nd Floor, : Mamoor Plaza, K.H.B . Colony, 50th Block, Koramangala)
                                </td>
                              </tr>
                              <tr>
                                <td>CONSIGNER FROM</td>
                                <td>:</td>
                                <td>Kirtan Pandya</td>
                              </tr>
                              <tr>
                                <td>CONTACT NO.</td>
                                <td>:</td>
                                <td>9874563215</td>
                              </tr>
                              <tr>
                                <td>SENDER GSTIN</td>
                                <td>:</td>
                                <td>24ABCDE1234F1GH</td>
                              </tr>
                              <tr>
                                <td>SENDER ID PROOF</td>
                                <td>:</td>
                                <td>AADHAR CARD</td>
                              </tr>
                              <tr>
                                <td>ID PROOF NO</td>
                                <td>:</td>
                                <td>1234 5678 9012</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td style={{ height: '100%', position: 'relative', verticalAlign: 'middle' }}>
                          <div
                            style={{
                              position: 'absolute',
                              left: '10px',
                              top: '0',
                              width: '1px',
                              height: '100%',
                              background: '#000',
                              zIndex: '1',
                            }}
                          ></div>
                          <svg
                            style={{
                              position: 'relative',
                              zIndex: '1',
                              background: '#fff',
                              padding: '2px',
                            }}
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M20 10C20 4.48 15.52 0 10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10ZM10 11H6V9H10V6L14 10L10 14V11Z"
                              fill="black"
                            />
                          </svg>
                        </td>
                        <td className="td-item">
                          <table>
                            <thead className="shade-bg bold-tx" style={{ lineHeight: '22px' }}>
                              <tr>
                                <td style={{ width: '40%' }}>DESTINATION CITY</td>
                                <td>:</td>
                                <td style={{ width: '60%' }}>Bangalore</td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td style={{ paddingTop: '5px' }}>DESTINATION BRANCH</td>
                                <td style={{ paddingTop: '5px' }}>:</td>
                                <td style={{ paddingTop: '5px' }}>
                                  {' '}
                                  Maven Operation Bangalore (2nd Floor, : Mamoor Plaza, K.H.B . Colony, 50th Block, Koramangala)
                                </td>
                              </tr>
                              <tr>
                                <td>CONSIGNEE FROM</td>
                                <td>:</td>
                                <td>Kirtan Pandya</td>
                              </tr>
                              <tr>
                                <td>CONTACT NO.</td>
                                <td>:</td>
                                <td>9874563215</td>
                              </tr>
                              <tr>
                                <td>RECEIVER GSTIN</td>
                                <td>:</td>
                                <td>24ABCDE1234F1GH</td>
                              </tr>
                              <tr>
                                <td>RECEIVER ID PROOF</td>
                                <td>:</td>
                                <td>AADHAR CARD</td>
                              </tr>
                              <tr>
                                <td>ID PROOF NO</td>
                                <td>:</td>
                                <td>1234 5678 9012</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </td>
              <td style={{ background: '#000' }}>
                <img src="http://buscrs.com/images/02.png" alt="" />
              </td>
            </tr>
          </table>
        </div>
        <div className="bottom-other-info">
          <div className="bold-tx heading-tx" style={{ marginTop: 0 }}>
            LEGAL COMPLIANCE
          </div>
          <table className="border-tb padding-td" style={{ width: '100%' }}>
            <thead className="shade-bg">
              <tr style={{ textTransform: 'capitalize' }}>
                <td>party bill number</td>
                <td>party bill date</td>
                <td>party bill value</td>
                <td>declared value</td>
                <td>eway bill numbers</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>WB789012</td>
                <td>2024-01-29</td>
                <td>800.00</td>
                <td>750.00</td>
                <td>1234 5678 7890, 2345 5678 7890, 1234 8765 5432, 1234 5678 7890, 2345 5678 7890</td>
              </tr>
            </tbody>
          </table>
          <div className="bold-tx heading-tx">GOODS DECLARATION</div>
          <table className="border-tb padding-td">
            <thead className="shade-bg">
              <tr>
                <td>ITEM TYPE</td>
                <td>METHOD OF PACKING</td>
                <td>GOODS DESCRIPTION (SAID TO CONTAIN)</td>
                <td>TOTAL UNITS</td>
                <td>GOODS VALUE</td>
                <td>ACTUAL WEIGHT</td>
                <td>CHARGED WEIGHT</td>
                <td>CHARGE RATE</td>
                <td>CHARGE FREIGHT</td>
              </tr>
            </thead>
            <tbody className="padding-td">
              <tr>
                <td>Carry bag</td>
                <td>Bag</td>
                <td>Sample of Medicines</td>
                <td>10</td>
                <td>1000</td>
                <td>10</td>
                <td>10</td>
                <td>10/KG</td>
                <td>100</td>
              </tr>
              <tr>
                <td>Carry bag</td>
                <td>Bag</td>
                <td>Sample of Medicines</td>
                <td>10</td>
                <td>1000</td>
                <td>10</td>
                <td>10</td>
                <td>10/KG</td>
                <td>100</td>
              </tr>
            </tbody>
          </table>
          <div className="bold-tx heading-tx">OTHER CHARGES</div>
          <table className="border-tb">
            <thead className="shade-bg">
              <tr>
                <td>TOTAL FREIGHT</td>
                <td>COLLECTION CARTAGE</td>
                <td>DELIVERY CARTAGE</td>
                <td>HAMALI CHARGE</td>
                <td>OP HAMALI CHARGE</td>
                <td>VALUATION CHARGE</td>
                <td>DOC CHARGE</td>
                <td>PICKUP CHARGE</td>
                <td>DROPOFF CHARGE</td>
                <td>GST AMT</td>
                <td style={{ background: '#000', color: '#fff', borderBottom: '1px solid #fff', whiteSpace: 'nowrap' }}>TOTAL</td>
              </tr>
            </thead>
            <tbody className="padding-td">
              <tr>
                <td>50</td>
                <td>10</td>
                <td>15</td>
                <td>8</td>
                <td>5</td>
                <td>12</td>
                <td>7</td>
                <td>10</td>
                <td>12</td>
                <td>8</td>
                <td style={{ background: '#000', color: '#fff', borderTop: '1px solid #fff' }}>150</td>
              </tr>
            </tbody>
          </table>
          {!delivery && (
            <>
              <div className="bold-tx heading-tx">RULES AND REGULATIONS</div>
              <p style={{ textAlign: 'justify', fontSize: '8px' }}>
                1. Parcel / Luggage / Covers are carried at owner s risk. 2. In case the parcels are loss or damaged on transit the Company
                will not take any liabilities on it. 3. Contraband articles are not permitted to be carried in the vehicles. The Parcel /
                Luggage / Cover owners or their agents will bear sole responsibility in case any objectionable / contraband goods are found
                in the packages on checked by octroi, excise or any other authority . Octroi will be levied on goods entering Mumbai. 4. We
                do not hold any responsibility on the late arrival of Parcel / Cover / Luggage. 5. Any enquiry regarding this parcel should
                be made within a week if not the company is not responsible. 6. In case the luggage is not collected within 7 days demurrage
                will be charged 10% on the Total Bill. 7. Above 20 Kgs service charges will be charged @ 10% of the Total Bill. 8. Cash will
                not be accepted as parcel. If without our knowledge cash is sent company does not take any responsibility for misplacement
                or loss
              </p>

              <div className="bold-tx heading-tx">CONSIGNOR DECLARATION</div>
              <table className="border-tb padding-td" width="100%" style={{ width: '100%' }}>
                <tr>
                  <td style={{ textAlign: 'justify' }}>
                    We hereby agree to the terms and conditions set out on the above of this consignor copy and declare that the contents on
                    this way bill are true and correct. The Topay freight has my/our consent and will be paid by the consignee along with
                    other charges and delivery charges as per actual at the time of delivery
                  </td>
                  <td style={{ width: '160px' }}>
                    <div style={{ width: '160px' }}>
                      <span className="sign-block">CONSIGNOR NAME:</span>
                      <span className="empty-block"></span>
                    </div>
                  </td>
                  <td style={{ width: '160px' }}>
                    <div style={{ width: '160px' }}>
                      <span className="sign-block">CONSIGNOR SIGN:</span>
                      <span className="empty-block"></span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colSpan="2">
                    REMARKS (IF ANY): <span>No remarks</span>{' '}
                  </td>
                  <td>
                    BOOKED BY: <span>John Doe</span>{' '}
                  </td>
                </tr>
              </table>
            </>
          )}

          {delivery ? (
            <>
              <div className="bold-tx heading-tx">DELIVERY CHARGES</div>
              <table className="border-tb">
                <thead className="shade-bg">
                  <tr>
                    <td>TOTAL AMOUNT</td>
                    <td>DELIVERY HAMALI</td>
                    <td>DELIVERY OPERATOR HAMALI</td>
                    <td>DELIVERY CHARGE</td>
                    <td>DEMURRAGE CHARGE</td>
                    <td>DELIVERY GST</td>
                    <td>DELIVERY DISCOUNT</td>
                    <td
                      style={{
                        background: '#000',
                        color: '#fff',
                        borderBottom: '1px solid #fff',
                      }}
                    >
                      TOTAL OUTSTANDING
                    </td>
                  </tr>
                </thead>
                <tbody className="padding-td">
                  <tr>
                    <td>1100</td>
                    <td>10</td>
                    <td>10</td>
                    <td>10</td>
                    <td>10</td>
                    <td>10</td>
                    <td>10</td>
                    <td
                      style={{
                        background: '#000',
                        color: '#fff',
                        borderTop: '1px solid #fff',
                      }}
                    >
                      12345
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="bold-tx heading-tx">CONSIGNEE DECLARATION</div>
              <table className="border-tb padding-td-lg" width="100%">
                <tr>
                  <td rowspan="2" style={{ textAlign: 'justify', width: '140px' }}>
                    RECEIVED THE ABOVE NOTED CONSIGNMENT IN ORDER AND CONDITION:
                  </td>
                  <td>CONSIGNEE NAME:</td>
                  <td rowspan="2" style={{ width: '180px' }}>
                    CONSIGNEE SIGN:
                  </td>
                </tr>
                <tr>
                  <td>CONSIGNEE MOBILE:</td>
                </tr>
              </table>
            </>
          ) : (
            ''
          )}
          <table className="border-tb padding-td text-cap" style={{ width: '100%' }}>
            <tr>
              <td>
                HELPLINE NO: <span>(555) 123-4567</span>
              </td>
              <td>
                website: <span>www.example.com</span>
              </td>
              <td>
                Print date: <span>2024-01-29</span>
              </td>
              <td>
                print time: <span>12:30 PM</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div className="page-break" style={{ pageBreakBefore: 'always' }}></div>
      <div style={{ width: '210mm', margin: '0 auto', background: '#fff', border: '2px solid #000', display: 'none' }}>
        <div className="top-main-info">
          <table cellSpacing="0" cellPadding="0">
            <tr>
              <td style={{ background: '#000' }}>
                <img src="http://buscrs.com/images/office01.png" alt="" />
              </td>
              <td className="item" style={{ width: '100%' }}>
                <div>
                  <table style={{ width: '100%' }} className="top-table">
                    <tbody>
                      <tr>
                        <td className="logo-box" rowSpan="2">
                          <div style={{ textAlign: 'center' }}>
                            <img src="https://mavenconnect.biz/maventech-logo.png" width="60px" height="60px" alt="Logo" />
                          </div>
                          <div className="medium-tx">
                            BOOKING TIME: <span>9:00 AM</span>
                          </div>
                        </td>
                        <td className="shade-bg">WAYBILL NO (LRN)</td>
                        <td className="shade-bg">Scan</td>
                        <td className="shade-bg">Total amount</td>
                        <td className="shade-bg">Payment Type</td>
                      </tr>
                      <tr>
                        <td>
                          <div>
                            <div className="medium-tx bold-tx">WB123456</div>
                            <div className="large-tx bold-tx">Booked</div>
                          </div>
                        </td>
                        <td>
                          <img
                            src="https://cdn.pixabay.com/photo/2013/07/12/14/42/qr-code-148603_1280.png"
                            alt="QR Code"
                            width="60px"
                            height="60px"
                          />
                        </td>
                        <td className="large-tx bold-tx">₹12345.00</td>
                        <td>
                          <div>
                            <div class="medium-tx bold-tx">
                              on account <br /> Manual
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="itenerary-box">
                    <table style={{ margin: '5px' }}>
                      <tr>
                        <td className="td-item">
                          <table>
                            <thead className="shade-bg bold-tx" style={{ lineHeight: '22px' }}>
                              <tr>
                                <td style={{ width: '40%' }}>SOURCE CITY</td>
                                <td>:</td>
                                <td style={{ width: '60%' }}>Bangalore</td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td style={{ paddingTop: '5px' }}>SOURCE BRANCH</td>
                                <td style={{ paddingTop: '5px' }}>:</td>
                                <td style={{ paddingTop: '5px' }}>
                                  Maven Operation Bangalore (2nd Floor, : Mamoor Plaza, K.H.B . Colony, 50th Block, Koramangala)
                                </td>
                              </tr>
                              <tr>
                                <td>CONSIGNER FROM</td>
                                <td>:</td>
                                <td>Kirtan Pandya</td>
                              </tr>
                              <tr>
                                <td>CONTACT NO.</td>
                                <td>:</td>
                                <td>9874563215</td>
                              </tr>
                              <tr>
                                <td>SENDER GSTIN</td>
                                <td>:</td>
                                <td>24ABCDE1234F1GH</td>
                              </tr>
                              <tr>
                                <td>SENDER ID PROOF</td>
                                <td>:</td>
                                <td>AADHAR CARD</td>
                              </tr>
                              <tr>
                                <td>ID PROOF NO</td>
                                <td>:</td>
                                <td>1234 5678 9012</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td style={{ height: '100%', position: 'relative', verticalAlign: 'middle' }}>
                          <div
                            style={{
                              position: 'absolute',
                              left: '10px',
                              top: '0',
                              width: '1px',
                              height: '100%',
                              background: '#000',
                              zIndex: '1',
                            }}
                          ></div>
                          <svg
                            style={{
                              position: 'relative',
                              zIndex: '1',
                              background: '#fff',
                              padding: '2px',
                            }}
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M20 10C20 4.48 15.52 0 10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10ZM10 11H6V9H10V6L14 10L10 14V11Z"
                              fill="black"
                            />
                          </svg>
                        </td>
                        <td className="td-item">
                          <table>
                            <thead className="shade-bg bold-tx" style={{ lineHeight: '22px' }}>
                              <tr>
                                <td style={{ width: '40%' }}>DESTINATION CITY</td>
                                <td>:</td>
                                <td style={{ width: '60%' }}>Bangalore</td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td style={{ paddingTop: '5px' }}>DESTINATION BRANCH</td>
                                <td style={{ paddingTop: '5px' }}>:</td>
                                <td style={{ paddingTop: '5px' }}>
                                  {' '}
                                  Maven Operation Bangalore (2nd Floor, : Mamoor Plaza, K.H.B . Colony, 50th Block, Koramangala)
                                </td>
                              </tr>
                              <tr>
                                <td>CONSIGNEE FROM</td>
                                <td>:</td>
                                <td>Kirtan Pandya</td>
                              </tr>
                              <tr>
                                <td>CONTACT NO.</td>
                                <td>:</td>
                                <td>9874563215</td>
                              </tr>
                              <tr>
                                <td>RECEIVER GSTIN</td>
                                <td>:</td>
                                <td>24ABCDE1234F1GH</td>
                              </tr>
                              <tr>
                                <td>RECEIVER ID PROOF</td>
                                <td>:</td>
                                <td>AADHAR CARD</td>
                              </tr>
                              <tr>
                                <td>ID PROOF NO</td>
                                <td>:</td>
                                <td>1234 5678 9012</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </td>
              <td style={{ background: '#000' }}>
                <img src="http://buscrs.com/images/office02.png" alt="" />
              </td>
            </tr>
          </table>
        </div>
        <div className="bottom-other-info">
          <div className="bold-tx heading-tx" style={{ marginTop: 0 }}>
            LEGAL COMPLIANCE
          </div>
          <table className="border-tb padding-td" style={{ width: '100%' }}>
            <thead className="shade-bg">
              <tr style={{ textTransform: 'capitalize' }}>
                <td>party bill number</td>
                <td>party bill date</td>
                <td>party bill value</td>
                <td>declared value</td>
                <td>eway bill numbers</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>WB789012</td>
                <td>2024-01-29</td>
                <td>800.00</td>
                <td>750.00</td>
                <td>1234 5678 7890, 2345 5678 7890, 1234 8765 5432, 1234 5678 7890, 2345 5678 7890</td>
              </tr>
            </tbody>
          </table>
          <div className="bold-tx heading-tx">GOODS DECLARATION</div>
          <table className="border-tb padding-td">
            <thead className="shade-bg">
              <tr>
                <td>ITEM TYPE</td>
                <td>METHOD OF PACKING</td>
                <td>GOODS DESCRIPTION (SAID TO CONTAIN)</td>
                <td>TOTAL UNITS</td>
                <td>GOODS VALUE</td>
                <td>ACTUAL WEIGHT</td>
                <td>CHARGED WEIGHT</td>
                <td>CHARGE RATE</td>
                <td>CHARGE FREIGHT</td>
              </tr>
            </thead>
            <tbody className="padding-td">
              <tr>
                <td>Carry bag</td>
                <td>Bag</td>
                <td>Sample of Medicines</td>
                <td>10</td>
                <td>1000</td>
                <td>10</td>
                <td>10</td>
                <td>10/KG</td>
                <td>100</td>
              </tr>
              <tr>
                <td>Carry bag</td>
                <td>Bag</td>
                <td>Sample of Medicines</td>
                <td>10</td>
                <td>1000</td>
                <td>10</td>
                <td>10</td>
                <td>10/KG</td>
                <td>100</td>
              </tr>
            </tbody>
          </table>
          <div className="bold-tx heading-tx">OTHER CHARGES</div>
          <table className="border-tb">
            <thead className="shade-bg">
              <tr>
                <td>TOTAL FREIGHT</td>
                <td>COLLECTION CARTAGE</td>
                <td>DELIVERY CARTAGE</td>
                <td>HAMALI CHARGE</td>
                <td>OP HAMALI CHARGE</td>
                <td>VALUATION CHARGE</td>
                <td>DOC CHARGE</td>
                <td>PICKUP CHARGE</td>
                <td>DROPOFF CHARGE</td>
                <td>GST AMT</td>
                <td style={{ background: '#000', color: '#fff', borderBottom: '1px solid #fff', whiteSpace: 'nowrap' }}>TOTAL</td>
              </tr>
            </thead>
            <tbody className="padding-td">
              <tr>
                <td>50</td>
                <td>10</td>
                <td>15</td>
                <td>8</td>
                <td>5</td>
                <td>12</td>
                <td>7</td>
                <td>10</td>
                <td>12</td>
                <td>8</td>
                <td style={{ background: '#000', color: '#fff', borderTop: '1px solid #fff' }}>150</td>
              </tr>
            </tbody>
          </table>
          {!delivery && (
            <>
              <div className="bold-tx heading-tx">RULES AND REGULATIONS</div>
              <p style={{ textAlign: 'justify', fontSize: '8px' }}>
                1. Parcel / Luggage / Covers are carried at owner s risk. 2. In case the parcels are loss or damaged on transit the Company
                will not take any liabilities on it. 3. Contraband articles are not permitted to be carried in the vehicles. The Parcel /
                Luggage / Cover owners or their agents will bear sole responsibility in case any objectionable / contraband goods are found
                in the packages on checked by octroi, excise or any other authority . Octroi will be levied on goods entering Mumbai. 4. We
                do not hold any responsibility on the late arrival of Parcel / Cover / Luggage. 5. Any enquiry regarding this parcel should
                be made within a week if not the company is not responsible. 6. In case the luggage is not collected within 7 days demurrage
                will be charged 10% on the Total Bill. 7. Above 20 Kgs service charges will be charged @ 10% of the Total Bill. 8. Cash will
                not be accepted as parcel. If without our knowledge cash is sent company does not take any responsibility for misplacement
                or loss
              </p>
              <div className="bold-tx heading-tx">CONSIGNOR DECLARATION</div>
              <table className="border-tb padding-td" width="100%" style={{ width: '100%' }}>
                <tr>
                  <td style={{ textAlign: 'justify' }}>
                    We hereby agree to the terms and conditions set out on the above of this consignor copy and declare that the contents on
                    this way bill are true and correct. The Topay freight has my/our consent and will be paid by the consignee along with
                    other charges and delivery charges as per actual at the time of delivery
                  </td>
                  <td style={{ width: '160px' }}>
                    <div style={{ width: '160px' }}>
                      <span className="sign-block">CONSIGNOR NAME:</span>
                      <span className="empty-block"></span>
                    </div>
                  </td>
                  <td style={{ width: '160px' }}>
                    <div style={{ width: '160px' }}>
                      <span className="sign-block">CONSIGNOR SIGN:</span>
                      <span className="empty-block"></span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colSpan="2">
                    REMARKS (IF ANY): <span>No remarks</span>{' '}
                  </td>
                  <td>
                    BOOKED BY: <span>John Doe</span>{' '}
                  </td>
                </tr>
              </table>
            </>
          )}
          {delivery ? (
            <>
              <div className="bold-tx heading-tx">DELIVERY CHARGES</div>
              <table className="border-tb">
                <thead className="shade-bg">
                  <tr>
                    <td>TOTAL AMOUNT</td>
                    <td>DELIVERY HAMALI</td>
                    <td>DELIVERY OPERATOR HAMALI</td>
                    <td>DELIVERY CHARGE</td>
                    <td>DEMURRAGE CHARGE</td>
                    <td>DELIVERY GST</td>
                    <td>DELIVERY DISCOUNT</td>
                    <td
                      style={{
                        background: '#000',
                        color: '#fff',
                        borderBottom: '1px solid #fff',
                      }}
                    >
                      TOTAL OUTSTANDING
                    </td>
                  </tr>
                </thead>
                <tbody className="padding-td">
                  <tr>
                    <td>1100</td>
                    <td>10</td>
                    <td>10</td>
                    <td>10</td>
                    <td>10</td>
                    <td>10</td>
                    <td>10</td>
                    <td
                      style={{
                        background: '#000',
                        color: '#fff',
                        borderTop: '1px solid #fff',
                      }}
                    >
                      12345
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="bold-tx heading-tx">CONSIGNEE DECLARATION</div>
              <table className="border-tb padding-td-lg" width="100%">
                <tr>
                  <td rowspan="2" style={{ textAlign: 'justify', width: '140px' }}>
                    RECEIVED THE ABOVE NOTED CONSIGNMENT IN ORDER AND CONDITION:
                  </td>
                  <td>CONSIGNEE NAME:</td>
                  <td rowspan="2" style={{ width: '180px' }}>
                    CONSIGNEE SIGN:
                  </td>
                </tr>
                <tr>
                  <td>CONSIGNEE MOBILE:</td>
                </tr>
              </table>
            </>
          ) : (
            ''
          )}
          <table className="border-tb padding-td text-cap" style={{ width: '100%' }}>
            <tr>
              <td>
                HELPLINE NO: <span>(555) 123-4567</span>
              </td>
              <td>
                website: <span>www.example.com</span>
              </td>
              <td>
                Print date: <span>2024-01-29</span>
              </td>
              <td>
                print time: <span>12:30 PM</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  )
}
